var React = require('react');
var ReactNative = require('react-native');

const Icon = require('./wrappers/ReUpIcon');
var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');
var ModelConstants = require('./constants/ModelConstants');

var Globals = require('./Globals');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton');
var ReUpText = require('./ReUpText');

var {
  AppRegistry,
  Text,
  View,
  Image,
  Animated,
  ScrollView,
  Platform,
  Animated,
  StyleSheet,
} = ReactNative;

var Gifts = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function()
  {

  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = this.state.user;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");

    var cardNumberLabel = "Gift Card Number";//TODO:localize
    var pinLabel = "PIN:";//TODO:localize
    var creditsPointLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
    var absorbCardButton = "Enter PIN";//TODO:localize

    var buttons = [];
    var sendGCFeature = appManager.getFeatureForName("SendGiftCard");
    if( typeof sendGCFeature !== 'undefined' && sendGCFeature != null ) buttons.push(sendGCFeature);
    var absorbFeature = appManager.getFeatureForName("AbsorbGiftCard");
    if( typeof absorbFeature !== 'undefined' && absorbFeature != null ) buttons.push(absorbFeature);
    // var sendCreditFeature = appManager.getFeatureForName("SendCredit");
    // if( typeof sendCreditFeature !== 'undefined' && sendCreditFeature != null ) buttons.push(sendCreditFeature);

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var iconName = this.props.featureData.icon.replace("fa-", "")
    var instructionText = locManager.localizedStringForKey(this.props.featureData.instructions);

    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this}>
          <View style={{flex:-1, backgroundColor:instructionColor, alignItems:'center', justifyContent:'center', padding:12}}>
            <Icon name={iconName} size={140} color={instructionTitleColor} style={{backgroundColor:'transparent'}}/>
            <ReUpText appManager={appManager} isTitle={true} style={{color:instructionTitleColor, textAlign:'center'}}>
              {instructionText}
            </ReUpText>
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          <View style={{padding:20}}>
            {
              buttons.map(function(feature, index)
              {
                return (<ReUpButton key={index} isSecondary={index != 0} appManager={appManager} style={[{marginBottom:20}]} text={feature.data.title}
                  onPress={()=>{appActions.requestFeatureName(feature.data.name)}} />)
              })
            }
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:50,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    margin:10,
    alignItems:'center',
    marginLeft:20,
    marginRight:20,
    justifyContent:'center',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize:26,
    padding:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    padding:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    flex:1,
    width:-1,
    height:50,
    marginTop:10
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems:'flex-end',
    margin:8,
    marginTop:0,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
    marginRight:10, marginLeft:10, marginBottom:10,
  },

  segmentContainer: {
    height:50,
    padding:4,
    flex:1,
    alignSelf:'center'
  }
});

Gifts.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn || typeof ModelConstants === 'undefined' ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = user[ModelConstants.Credits]
    if( credit < 20) return [];

    var didSelect = function() {appActions.requestFeatureName("AbsorbGiftCard")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}

Gifts.dataDependencies = ["Users"];

module.exports = Gifts;
